import { IconGrid } from '@docs/helpers';
import { Playground } from 'docz';
import * as Icons from "../../../../../builder-ui/app/src/icons";
import * as React from 'react';
export default {
  IconGrid,
  Playground,
  Icons,
  React
};